import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import heroStyles from "./Hero.module.css";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const Hero = () => {
  const slideImages = [
    {
      src: "/home1.png", // Removed extra quotes and fixed path
      alt: "Damaged box appliances",
    },
    {
      src: "/home2.png", // Removed extra quotes and fixed path
      alt: "No box items",
    },
    {
      src: "/home3.png", // Removed extra quotes and fixed path
      alt: "Quality products",
    },
    {
      src: "/home4.png", // Removed extra quotes and fixed path
      alt: "Quality products",
    },
    {
      src: "/home5.png", // Removed extra quotes and fixed path
      alt: "Quality products",
    },
    {
      src: "/home6.png", // Removed extra quotes and fixed path
      alt: "Quality products",
    },
  ];

  return (
    <section className={`${heroStyles.herobg} my-3`}>
      <Container className={`${heroStyles.herocontainer} py-lg-5 pt-5`}>
        <Row className="align-items-center">
          <Col lg={6} md={12} className="order-2 order-lg-1">
            <div>
              <h2 className={heroStyles.herotitle}>About US: </h2>
              <p className="my-3">
                In a world that often prioritizes appearances, BLINQ challenges
                the notion that external packaging defines value. We understand
                that what truly matters is the quality and functionality of the
                products inside. That's why we specialize in offering an
                exceptional selection of open box, damaged box, and no-box
                items—all rigorously inspected to ensure they meet our high
                standards. Our commitment to quality allows us to provide
                unbeatable prices, ensuring that you receive top-notch products
                without paying a premium for the packaging. With BLINQ, you can
                enjoy significant savings while embracing the idea that true
                worth lies beneath the surface. Discover the smart way to shop,
                where affordability meets reliability, and experience the joy of
                finding quality products without compromising your budget.
              </p>
              <Button variant="dark" className={`${heroStyles.herobtn} my-3`}>
                <Link to="/shop" className="text-decoration-none text-white">
                  {" "}
                  Shop Now
                </Link>
              </Button>
            </div>
          </Col>
          <Col lg={6} md={12} className="order-1 order-lg-2 mb-4 mb-lg-0">
            <div className={heroStyles.brandGrid}>
              {Array.from({ length: 29 }, (_, i) => (
                <img
                  key={i}
                  src={`/brands logo/brand${i + 1}.png`} 
                  alt={`Brand ${i + 1}`}
                  className={heroStyles.brandLogo}
                  onError={(e) => {
                    e.target.style.display = "none";
                    console.error(
                      `Failed to load logo: /brands/brand${i + 1}.png` 
                    );
                  }}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
